







































import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
import { HeaderColumn } from "#/components/selectFilter/filter";
import AxiosMixin from "@/mixins/axiosMixin";

type adminUser = {
  id: number;
  last_name: string;
  first_name: string;
  mail_address: string;
  auth_name: string;
};

@Component
export default class AssignDialog extends Mixins(AxiosMixin) {
  /** ダイアログ表示フラグ */
  @Prop({ default: false }) value!: boolean;

  /** ダイアログ表示フラグ更新 */
  @Emit("input") private updateValue(val: boolean) {
    return val;
  }

  /** メンバー登録イベント発火 */
  @Emit("save") private emitSave() {
    return this.selectedRecords;
  }

  /** 選択可能事業所のヘッダ */
  private headers: HeaderColumn[] = [
    { text: "姓", value: "last_name", sortable: true },
    { text: "名", value: "first_name", sortable: true },
    { text: "メールアドレス", value: "mail_address", sortable: true },
    { text: "権限名", value: "auth_name", sortable: true },
    { text: "アサイン数", value: "assigned_inquiry_count", sortable: true },
    {
      text: "アサイン数(公開/未対応)",
      value: "no_process_assigned_inquiry_count",
      sortable: true,
    },
  ];

  /** 選択可能事業所のデータ */
  private records: adminUser[] = [];

  /** 選択可能事業所の選択データ */
  private selectedRecords: adminUser[] = [];

  /** 絞込み用キーワード */
  private searchKey = "";

  /** ダイアログ表示フラグ */
  private get Value(): boolean {
    return this.value;
  }
  private set Value(val: boolean) {
    this.updateValue(val);
  }

  @Watch("Value") onDialogChange(val: boolean) {
    if (val) {
      this.postJsonCheck(
        window.base_url + "/api/admin/assignable_admin_users/get",
        {},
        (res) => {
          this.records = res.data.admin_users;
          this.selectedRecords = res.data.select_admin_users;
        }
      );
    }
  }
}
